<script setup>
import Dropdown from '../../../../_02_molecules/components/Dropdown.vue';
import useInvoiceModalStore from '../../store/invoiceModal';
import UpdateSubscriptionAction from '../actions/UpdateSubscriptionAction.vue';
import { trans } from '../../../../_00_elements/translation';
import CreateInvoiceAction from '../actions/CreateInvoiceAction.vue';
import ExtendSubscriptionAction from '../actions/ExtendSubscriptionAction.vue';
import CloseSubscriptionAction from '../actions/CloseSubscriptionAction.vue';
import { SUBSCRIPTION_STATUS } from '../../constants/constants';

const { setModal } = useInvoiceModalStore();

const props = defineProps({
  subscription: {
    type: Object,
    default: null,
  },
});

const openModal = ({ title, name }) => {
  setModal({
    modalTitle: title,
    modalComponentName: name,
    shouldOpenModal: true,
  });
};
</script>

<template>
  <span v-if="subscription" class="subscription-details__dropdown">
    <Dropdown position-strategy="fixed" align="end" fit-anchor-width :label="trans('offer.actions')">
      <template #dropdownMenu>
        <template v-if="props.subscription.status === SUBSCRIPTION_STATUS.ACTIVE">
          <UpdateSubscriptionAction @openModal="openModal" />
          <CreateInvoiceAction @openModal="openModal" />
          <ExtendSubscriptionAction v-if="!!props.subscription.end_date" @openModal="openModal" />
          <CloseSubscriptionAction @openModal="openModal" />
        </template>
      </template>
    </Dropdown>
  </span>
</template>
